import DateFnsUtils from "@date-io/date-fns";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Snackbar, TextField, Typography } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import styles from "./Styles/BookScreenStyles";
import API from "../Services/API";
import Loading from "./Loading";
import validator from "validator";
import { NONE } from "apisauce";

const PersonalInformation = (props, ref) => {
  let { classes } = props;
  const [selectedDOB, setSelectedDOB] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedVisitType, setSelectedVisitType] = useState("Office Visit");
  const [selectedInsName, setSelectedInsName] = useState("");
  const [selectedVisitReason, setSelectedVisitReason] = useState("");
  const [isNewPatient, setIsNewPatient] = useState("");
  const [isPrimaryIns, setIsPrimaryIns] = useState("yes");
  const [isdisabled, setdisabled] = useState("yes");
  const [selectRelation, setSelectRelation] = useState("");
  const [verified, setverified] = useState(false);
  const [selectRelationName, setSelectRelationName] = useState("");
  const [primaryHolderFname, setPrimaryHolderFname] = useState(props.infoScreen.primaryCardHolderFname || "");
  const [primaryHolderLname, setPrimaryHolderLname] = useState(props.infoScreen.primaryCardHolderLname || "");
  const [didInitLoad, setDidInitLoad] = useState(false);
  const [insMandatory, setinsMandatory] = useState(false);
  const [noData, setNoData] = useState("");
  const [insNamesData, setInsNamesData] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState(false);
  const [visitReasons, setVisitReasons] = useState("");
  const [visitApptType, setVisitApptType] = useState("");
  const [selecteVistReasonData, setSelecteVistReasonData] = useState("");
  const [selectedInsValue, setselectedInsValue] = useState("");
  const [referenceRelationData, setReferenceRelationData] = useState("");
  const [defaultQuickBook, setDefaultQuickBook] = useState("");
  let [fname, setfname] = useState(props.infoScreen.Fname);
  let [lname, setlname] = useState(props.infoScreen.Lname);
  let [email, setemail] = useState(props.infoScreen.email);
  let [address, setaddress] = useState(props.infoScreen.address);
  let [cellNumb, setcellNumb] = useState(props.infoScreen.CellNum);
  let [insNum, setInsNum] = useState("");
  // If patientId is present, start with popup hidden — we only show it after API confirms no data
  const hasPatientId = props.infoScreen.patientId && props.infoScreen.patientId !== "-1" && props.infoScreen.patientId !== "";
  let [Dobup, setDobup] = useState(!hasPatientId);
  // Tracks whether the patientDetails fetch has completed (used to suppress popup during in-flight request)
  const [patientFetchDone, setPatientFetchDone] = useState(!hasPatientId);
  // Specialty intake Q&A answers — initialized from props (to restore on bindValuesForExit)
  const [specialtyAnswers, setSpecialtyAnswers] = useState(props.infoScreen.specialtyAnswers || {});
  const [specialtyQuestionsConfig, setSpecialtyQuestionsConfig] = useState(null);
  const [hideInsuranceIdConfig, setHideInsuranceIdConfig] = useState(false);
  const [hideNewPatientConfig, setHideNewPatientConfig] = useState(true);
  const isNewPatientHidden = hideNewPatientConfig || hasPatientId;
  const api = API.create();
  var lastName = "";
  var firstName = "";
  var cellNum = "";
  var formattdate = "";
  var patemail = "";
  var insId = "";
  var cardHolderFname = "";
  var cardHolderLname = "";

  useEffect(() => {
    console.log(props.infoScreen.dobset);
    if (props.infoScreen.fromBindExit) {
      setfname(props.infoScreen.Fname)
      setlname(props.infoScreen.Lname)
      setSelectedDOB(props.infoScreen.selecteddob)
      setemail(props.infoScreen.email)
      setaddress(props.infoScreen.address)
      setSelectedVisitType(props.infoScreen.selectVisitType)
      setcellNumb(props.infoScreen.CellNum)
      setSelectedVisitReason(props.infoScreen.selectedVisitReason)
      setSelecteVistReasonData(props.infoScreen.selectedVisitReasonValue)
      setSelectedInsName(props.infoScreen.selectedInsName)
      setselectedInsValue(props.infoScreen.selectedInsNameValue)
      setInsNum(props.infoScreen.insNum)
      setSelectRelation(props.infoScreen.relationId)
      setSelectRelationName(props.infoScreen.relationName)
      setIsNewPatient(props.infoScreen.isNewPatient)
      setPrimaryHolderFname(props.infoScreen.primaryCardHolderFname || "")
      setPrimaryHolderLname(props.infoScreen.primaryCardHolderLname || "")
      if (props.infoScreen.specialtyAnswers) {
        setSpecialtyAnswers(props.infoScreen.specialtyAnswers);
      }
      if (props.infoScreen.relationId && props.infoScreen.relationId !== "") {
        setIsPrimaryIns("no");
        setdisabled("No");
      } else {
        setIsPrimaryIns("yes");
        setdisabled("yes");
      }
      props.infoScreen.fromBindExit = false;
    }
    if (!didInitLoad) {
      initialLoad();
    }
  });

  if (ref !== null) {
    props.infoScreen.refCallMethod(ref);
  }

  const callExitVariable = () => {
    let lastName = document.getElementById("lastNameField").value;
    let firstName = document.getElementById("firstNameField").value;
    let cellNum = document.getElementById("cellNumField").value;
    let patemail = document.getElementById("emailField").value;
    let patAddress = document.getElementById("addressField") ? document.getElementById("addressField").value : address;
    let insId = document.getElementById("insuranceNumber").value;
    let formattdate = "";
    let selRelName = "";
    let selRel = "";
    let pFname = "";
    let pLname = "";
    if (isdisabled === "No") {
      selRelName = selectRelationName;
      selRel = selectRelation;
      pFname = primaryHolderFname;
      pLname = primaryHolderLname;
    } else {
      pFname = firstName;
      pLname = lastName;
    }
    if (selectedDOB !== null) {
      try {
        const year = selectedDOB.getFullYear();
        const month = selectedDOB.getMonth() + 1;
        const date = selectedDOB.getDate();
        formattdate = month
          .toString()
          .concat("/" + date.toString() + "/" + year.toString());
      } catch (e) {
        if (selectedDOB.includes("/")) {
          var datedata = selectedDOB.split("/");
          formattdate = (datedata[0].length > 1 ? datedata[0] : "0" + datedata[0]) + "/" + (datedata[1].length > 1 ? datedata[1] : "0" + datedata[1]) + "/" + datedata[2];
        }
      }

    }
    props.infoScreen.bindValuesForExit(
      lastName,
      firstName,
      cellNum,
      formattdate,
      selectedVisitType,
      selectedInsName,
      selectedVisitReason,
      selectedInsValue,
      selecteVistReasonData,
      isNewPatient,
      email,
      insId,
      selRel,
      selRelName,
      pFname,
      pLname,
      patAddress,
      specialtyAnswers
    )
  }

  const initialLoad = () => {
    setLoading(true);
    if (props.infoScreen.patientId && props.infoScreen.patientId !== "-1" && props.infoScreen.patientId !== "") {
      // Popup is already hidden (Dobup=false from init). Keep it hidden until fetch completes.
      api.getPatientDetails({ dbname: props.infoScreen.dbname, patientId: props.infoScreen.patientId }, (res) => {
        console.log("[getPatientDetails] raw response:", res);
        if (res.status === 200 && res.data && res.data !== "glaceportal_failure_exception") {
          const pd = res.data.data ? res.data.data : res.data;
          // Check if we got actual patient data (not empty object)
          const hasData = pd && (pd.patientRegistrationFirstName || pd.patientRegistrationLastName || pd.patientRegistrationId);
          if (hasData) {
            console.log("[getPatientDetails] patient object:", pd);
            if (pd.patientRegistrationFirstName) setfname(pd.patientRegistrationFirstName);
            if (pd.patientRegistrationLastName) setlname(pd.patientRegistrationLastName);
            // email — set from API if available, else leave blank (user will type)
            const apiEmail = pd.patientRegistrationMailId;
            setemail((apiEmail && apiEmail.trim() !== "" && apiEmail.trim() !== "null") ? apiEmail.trim() : "");
            // phone — set from API if available (strip non-digits), else leave blank (user will type)
            const rawPhone = pd.patientRegistrationCellno || pd.patientRegistrationPhoneNo;
            const digitsOnly = (rawPhone && rawPhone.trim() !== "" && rawPhone.trim() !== "null")
              ? rawPhone.replace(/\D/g, "")
              : "";
            setcellNumb(digitsOnly);
            // DOB: API returns epoch as string e.g. "285013800000", or MM-dd-yyyy, MM/dd/yyyy, yyyy-MM-dd
            const rawDob = pd.patientRegistrationDob;
            console.log("[getPatientDetails] raw DOB value:", rawDob);
            if (rawDob) {
              let parsedDate = null;
              if (typeof rawDob === 'number') {
                parsedDate = new Date(rawDob);
              } else if (typeof rawDob === 'string') {
                // epoch as string e.g. "285013800000" or "-402039000000" (negative = before 1970)
                if (/^-?\d+$/.test(rawDob.trim())) {
                  parsedDate = new Date(parseInt(rawDob, 10));
                }
                if (!parsedDate || isNaN(parsedDate)) {
                  const mmDdYyyy = rawDob.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
                  if (mmDdYyyy) {
                    parsedDate = new Date(`${mmDdYyyy[3]}-${mmDdYyyy[1].padStart(2, '0')}-${mmDdYyyy[2].padStart(2, '0')}`);
                  }
                }
                if (!parsedDate || isNaN(parsedDate)) {
                  const mmSlashDdYyyy = rawDob.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
                  if (mmSlashDdYyyy) {
                    parsedDate = new Date(`${mmSlashDdYyyy[3]}-${mmSlashDdYyyy[1].padStart(2, '0')}-${mmSlashDdYyyy[2].padStart(2, '0')}`);
                  }
                }
                if (!parsedDate || isNaN(parsedDate)) {
                  parsedDate = new Date(rawDob);
                }
              }
              console.log("[getPatientDetails] parsedDate:", parsedDate);
              if (parsedDate && !isNaN(parsedDate)) {
                setSelectedDOB(parsedDate);
              }
            }
            // Data found — keep popup hidden, mark verified
            setDobup(false);
            setverified(true);
            if (props.infoScreen.setIsAutoPopulated) {
              props.infoScreen.setIsAutoPopulated(true);
            }
          } else {
            // API returned 200 but no patient data — now show DOB popup
            console.log("[getPatientDetails] no patient data found, showing DOB popup");
            setDobup(true);
            if (props.infoScreen.setIsAutoPopulated) {
              props.infoScreen.setIsAutoPopulated(false);
            }
          }
        } else {
          // API error or failure — now show DOB popup
          console.log("[getPatientDetails] API error, showing DOB popup");
          setDobup(true);
          if (props.infoScreen.setIsAutoPopulated) {
            props.infoScreen.setIsAutoPopulated(false);
          }
        }
        // Mark fetch as done so render guard is released
        setPatientFetchDone(true);
      });
    }
    api.getSchedulerDetails(
      { dbname: props.infoScreen.dbname },
      (schDetails) => {
        if (schDetails.status === 200) {
          setNoData("false");
          let schDetailsObj = schDetails.data;
          if (schDetailsObj.schApptReasonList.length > 0) {
            setVisitReasons(schDetailsObj.schApptReasonList);
            if (props.infoScreen.modenew != undefined && props.infoScreen.modenew == 1) {
              for (let index = 0; index < schDetailsObj.schApptReasonList.length; index++) {
                if (schDetailsObj.schApptReasonList[index].app_Reference_Values_statusName == 'Referral') {
                  setSelectedVisitReason(schDetailsObj.schApptReasonList[index].app_Reference_Values_statusId);
                  setSelecteVistReasonData(schDetailsObj.schApptReasonList[index].app_Reference_Values_statusName);
                }
              }
            }
          }
          if (schDetailsObj.schApptTypeList.length > 0) {
            setVisitApptType(schDetailsObj.schApptTypeList);
          }
        } else {
          setNoData("true");
        }

      }
    );
    api.getDefaultQuickbookReason(
      { dbname: props.infoScreen.dbname },
      (schDetails) => {
        if (schDetails.status === 200) {
          setNoData("false");
          let defaultQuickBook = schDetails.data;
          for (let index = 0; index < defaultQuickBook.length; index++) {
            if (defaultQuickBook[index].patientPortalFeatureConfigName === "Default Appointment Reason") {
              let defaultQuickBookReason = defaultQuickBook[index].patientPortalFeatureConfigDesc;
              setDefaultQuickBook(defaultQuickBookReason);
            }
            if (defaultQuickBook[index].patientPortalFeatureConfigName === "Specialty Intake Questions") {
              if (defaultQuickBook[index].patientPortalFeatureConfigIsactive) {
                try {
                  let configJson = JSON.parse(defaultQuickBook[index].patientPortalFeatureConfigDesc);
                  setSpecialtyQuestionsConfig(configJson);
                } catch (e) {
                  console.error("Failed to parse Specialty Intake Questions config", e);
                }
              }
            }
            if (defaultQuickBook[index].patientPortalFeatureConfigName === "Hide Insurance ID") {
              setHideInsuranceIdConfig(defaultQuickBook[index].patientPortalFeatureConfigIsactive);
            }if (
              defaultQuickBook[index].patientPortalFeatureConfigName === "Hide New Patient" ||
              (defaultQuickBook[index].patientPortalFeatureConfigName &&
                defaultQuickBook[index].patientPortalFeatureConfigName.toLowerCase().replace(/[\s_-]/g, "").includes("hidenewpatient"))
            ) {
              setHideNewPatientConfig(defaultQuickBook[index].patientPortalFeatureConfigIsactive);
            }
          }
        }
      });
    api.getInsNames({ dbname: props.infoScreen.dbname }, (insNamesRes) => {
      if (insNamesRes.status === 200) {
        setNoData("false");
        let insNamesObj = insNamesRes.data;
        if (insNamesObj.length > 0) {
          setInsNamesData(insNamesObj);
        }
      } else {
        setNoData("true");
      }

    });
    api.getRelationReference({ dbname: props.infoScreen.dbname }, (referenceDetails) => {
      if (referenceDetails.status === 200) {
        setNoData("false");
        let referenceDetailsObj = referenceDetails.data;
        if (referenceDetailsObj.length > 0) {
          setReferenceRelationData(referenceDetailsObj);
        } else {
          setNoData("true");
        }
      }
    });
    setLoading(false);
    setDidInitLoad(true);
  }
  const handleDateChange = (date) => {
    setSelectedDOB(date);
  };
  const checkTheNumberCount = (event) => {
    let clNo = event.target.value;
    if (isNaN(clNo))
      event.target.value = event.target.value.slice(0, clNo.length - 1)
    if (clNo.length >= 10)
      event.target.value = event.target.value.slice(0, 10)
    setcellNumb(event.target.value);
  }
  const checkTheInsNumberCount = (event) => {
    let insNo = event.target.value;
    if (insNo.length >= 30)
      event.target.value = event.target.value.slice(0, 30);
    setInsNum(event.target.value);
  }
  var handleChange = (event) => {
    if (event.target.name === "apptTypeRadio") {
      setSelectedVisitType(event.target.value);
    } else if (event.target.name === "insNameSelect") {
      setSelectedInsName(event.target.value);

    } else if (event.target.name === "selectedVisitReason") {
      setSelectedVisitReason(event.target.value);
    } else if (event.target.name === "isNewPatientRadio") {
      setIsNewPatient(event.target.value);
    }
  };
  var handlePrimaryChange = (event) => {
    if (selectedInsName === "") {
      setOpenSnackBar(true);
      setSnackBarMessage("Please select your Insurance.");
    }
    else {
      setIsPrimaryIns(event.target.value);
      if (event.target.value === 'yes') {
        setdisabled("yes");
      } else {
        setdisabled("No");
      }
    }
  };
  var closeSnackBar = () => {
    setOpenSnackBar(false);
  };
  var confirmBooking = () => {
    lastName = document.getElementById("lastNameField").value;
    firstName = document.getElementById("firstNameField").value;
    cellNum = document.getElementById("cellNumField").value;
    patemail = document.getElementById("emailField").value;
    let patAddress = document.getElementById("addressField").value;
    insId = document.getElementById("insuranceNumber").value;
    cardHolderFname = document.getElementById("primaryHolderFname").value;
    cardHolderLname = document.getElementById("primaryHolderLname").value;
    formattdate = "";
    if (selectedDOB !== null) {
      try {
        const year = selectedDOB.getFullYear();
        const month = selectedDOB.getMonth() + 1;
        const date = selectedDOB.getDate();
        formattdate = month
          .toString()
          .concat("/" + date.toString() + "/" + year.toString());
      } catch (e) {
        if (selectedDOB.includes("/")) {
          var datedata = selectedDOB.split("/");
          formattdate = (datedata[0].length > 1 ? datedata[0] : "0" + datedata[0]) + "/" + (datedata[1].length > 1 ? datedata[1] : "0" + datedata[1]) + "/" + datedata[2];
        }
      }
    }

    if (lastName == "") {
      setOpenSnackBar(true);
      setSnackBarMessage("Please enter last name");
      return;
    }
    if (!/^[A-Za-z\s]+$/.test(lastName)) {
      setOpenSnackBar(true);
      setSnackBarMessage(
        "Please enter characters only in last and first name fields"
      );
      return;
    }

    if (firstName == "") {
      setOpenSnackBar(true);
      setSnackBarMessage("Please enter first name");
      return;
    }
    if (!/^[A-Za-z\s]+$/.test(firstName)) {
      setOpenSnackBar(true);
      setSnackBarMessage(
        "Please enter characters only in last and first name fields"
      );
      return;
    }


    if (cellNum === "") {
      setOpenSnackBar(true);
      setSnackBarMessage("Please enter Cell Number");
      return;
    }
    if (!cellNum.match(/^[0-9]+$/) || cellNum.length != 10) {
      setOpenSnackBar(true);
      setSnackBarMessage("Incorrect phone number.");
      return;
    }
    if (selectedDOB === null || selectedDOB.toString() === 'Invalid Date' || formattdate === "" || formattdate.includes("undefined") || formattdate.includes("NaN")) {
      setOpenSnackBar(true);
      setSnackBarMessage("Please enter a valid Date Of Birth");
      return;
    }

    if (selectedVisitType === "") {
      setOpenSnackBar(true);
      setSnackBarMessage("Please fill Visit type.");
      return;
    }

    if (selectedVisitReason === "") {
      setOpenSnackBar(true);
      setSnackBarMessage("Please select Visit reason.");
      return;
    }

    if (props.infoScreen.showSpecialtyQuestions && specialtyQuestionsConfig && specialtyQuestionsConfig.questions && specialtyQuestionsConfig.questions[props.infoScreen.specialtyType]) {
      let questions = specialtyQuestionsConfig.questions[props.infoScreen.specialtyType];
      for (let i = 0; i < questions.length; i++) {
        let q = questions[i];
        if (q.mandatory && (!specialtyAnswers[q.text] || specialtyAnswers[q.text].trim() === "")) {
          setOpenSnackBar(true);
          setSnackBarMessage(`Please answer the mandatory question: ${q.text}`);
          return;
        }
      }
    }
    if (insMandatory && !hideInsuranceIdConfig) {
      if (insId === "" || insId.length > 30) {
        setOpenSnackBar(true);
        setSnackBarMessage(
          "Insurance id cannot be empty.  "
        );
        return;
      }
    }
    if (patemail === "") {
      setOpenSnackBar(true);
      setSnackBarMessage(
        "Enter email id."
      );
      return;
    } else if (!validator.isEmail(patemail)) {
      setOpenSnackBar(true);
      setSnackBarMessage(
        "Invalid email id."
      );
      return;
    }
    if (isdisabled === "No") {

      if (cardHolderFname === "") {
        setOpenSnackBar(true);
        setSnackBarMessage(
          "Please enter Card holder First name"
        );
        return;
      }
      if (cardHolderLname === "") {
        setOpenSnackBar(true);
        setSnackBarMessage(
          "Please enter Card holder Last name"
        );
        return;
      }
      if (selectRelation === "") {
        setOpenSnackBar(true);
        setSnackBarMessage(
          "Please enter Card holder relation"
        );
        return;
      }
    }
    setfname(firstName);
    setlname(lastName);
    setemail(patemail);
    setaddress(patAddress);
    proceedToConfirmation(patemail, patAddress);

  }
  const proceedToConfirmation = (email, patAddress) => {
    let selRelName = "";
    let selRel = "";
    let pFname = "";
    let pLname = "";
    if (isdisabled === "No") {
      selRelName = selectRelationName;
      selRel = selectRelation;
      pFname = primaryHolderFname;
      pLname = primaryHolderLname;
    } else {
      pFname = firstName;
      pLname = lastName;
    }
    props.infoScreen.moveConfirmation(
      lastName,
      firstName,
      cellNum,
      formattdate,
      selectedVisitType,
      selectedInsName,
      selectedVisitReason,
      selectedInsValue,
      selecteVistReasonData,
      isNewPatient,
      email,
      insId,
      selRel,
      selRelName,
      pFname,
      pLname,
      patAddress,
      specialtyAnswers
    );
  }

  return (
    <div>
      {loading && (
        <Loading />
      )}
      {props.infoScreen.dobset !== '' && props.infoScreen.dobset !== undefined && Dobup && patientFetchDone && (

        <Dialog
          open={Dobup} // Open the dialog when Dobup is true
          onClose={(e, reason) => {
            console.log(reason);
            if (reason === 'backdropClick') {
              e.stopPropagation();
            }
            else {
              props.infoScreen.valu(false);
              setDobup(false)
            }
          }} PaperProps={{
            style: {
              borderRadius: '15px',  // Apply border-radius
              padding: '20px',  // Add padding around the content
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',  // Add shadow for depth
            }
          }}
        >
          <DialogTitle style={{ fontWeight: 'bold', padding: '16px 5px' }}>Please provide your DOB.</DialogTitle>
          <DialogContent style={{ padding: '8px 5px', paddingTop: '25px', paddingBottom: '20px' }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                fullWidth
                variant="inline"
                inputVariant="outlined"
                square
                format="MM/dd/yyyy"
                id="dob"
                label="DOB"
                placeholder="mm/dd/yyyy"
                disableFuture
                value={selectedDOB}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                InputProps={{
                  className: classes.inputField,
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldName,
                  },
                }}
                style={{
                  marginBottom: '20px', // Space below the date picker
                  borderRadius: '8px',  // Rounded corners for the date picker input
                }}
              />
            </MuiPickersUtilsProvider>
          </DialogContent>

          <DialogActions style={{ justifyContent: 'space-between', padding: '5px' }}>
            {/* Cancel Button */}
            <Button
              onClick={() => {
                setDobup(false);
                setfname('');
                setlname('');
                setemail('');
                setcellNumb('');
                setverified(true);
                props.infoScreen.valu(false);
              }}
              color="primary"
              style={{
                backgroundColor: '#e0e0e0',
                padding: '8px 16px', // Add some padding
                borderRadius: '10px',  // Rounded corners
                fontWeight: 'bold', // Bold text for emphasis
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Light shadow for depth
                transition: 'all 0.3s ease', // Smooth transition
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#b0b0b0'} // Hover effect
              onMouseLeave={(e) => e.target.style.backgroundColor = '#e0e0e0'} // Hover effect
            >
              Cancel
            </Button>

            {/* Submit Button */}
            <Button
              onClick={() => {
                if (selectedDOB == undefined || selectedDOB == null || selectedDOB == '' || selectedDOB.toString() === 'Invalid Date') {
                  setOpenSnackBar(true);
                  setSnackBarMessage("Please provide us with valid date");
                  return;
                }
                props.infoScreen.valu(false);
                setverified(true);
                setDobup(false);
                const selectedDate = new Date(selectedDOB);
                const selectedDateString = selectedDate.toLocaleDateString('en-US');
                const dobsetParts = props.infoScreen.dobset.split('-');
                const dobsetDate = new Date(`${dobsetParts[2]}-${dobsetParts[0]}-${dobsetParts[1]}`);
                const dobsetDateString = dobsetDate.toLocaleDateString('en-US');
                if (selectedDateString == dobsetDateString) {
                  setDobup(false);
                } else {
                  setfname('');
                  setlname('');
                  setemail('');
                  setcellNumb('');
                }
              }}
              color="primary"
              style={{
                backgroundColor: '#265a88',
                color: '#fff',
                padding: '8px 16px', // Add padding for better spacing
                borderRadius: '10px',  // Rounded corners for the button
                fontWeight: 'bold', // Bold text for better emphasis
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
                transition: 'all 0.3s ease', // Smooth transition
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#1b3c56'} // Darken button on hover
              onMouseLeave={(e) => e.target.style.backgroundColor = '#265a88'} // Revert color when hover ends
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {!loading && (props.infoScreen.dobset === undefined || props.infoScreen.dobset == '' || verified) && (
        <div>
          <Grid>
            <Grid container spacing={2} justify="space-between">
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  required
                  id="firstNameField"
                  name="firstName"
                  variant="outlined"
                  square
                  value={fname}
                  type="text"
                  label="First Name"
                  onChange={(event) => {
                    setfname(event.target.value);
                  }}
                  disabled={props.infoScreen.isAutoPopulated}
                  style={props.infoScreen.isAutoPopulated ? { pointerEvents: "none" } : {}}
                  InputProps={{
                    className: classes.inputField,
                    readOnly: props.infoScreen.isAutoPopulated
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.textFieldName,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  square
                  id="lastNameField"
                  name="lastName"
                  type="text"
                  label="Last Name"
                  value={lname}
                  onChange={(event) => {
                    setlname(event.target.value);
                  }}
                  disabled={props.infoScreen.isAutoPopulated}
                  style={props.infoScreen.isAutoPopulated ? { pointerEvents: "none" } : {}}
                  InputProps={{
                    className: classes.inputField,
                    readOnly: props.infoScreen.isAutoPopulated
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.textFieldName,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk={true}
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    square
                    format="MM/dd/yyyy"
                    id="dob"
                    label="DOB"
                    openTo="year"
                    disableFuture={true}
                    value={selectedDOB}
                    onChange={handleDateChange}
                    disabled={props.infoScreen.isAutoPopulated}
                    readOnly={props.infoScreen.isAutoPopulated}
                    style={props.infoScreen.isAutoPopulated ? { pointerEvents: "none" } : {}}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                      disabled: props.infoScreen.isAutoPopulated
                    }}
                    InputProps={{
                      className: classes.inputField,
                      readOnly: props.infoScreen.isAutoPopulated
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.textFieldName,
                      },
                    }}
                  />

                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} md={4} >
                <TextField
                  fullWidth
                  required
                  id="cellNumField"
                  name="Cell"
                  label="Cell"
                  variant="outlined"
                  value={cellNumb != undefined ? cellNumb.replace(' ', '') : ''}
                  square
                  onChange={checkTheNumberCount}
                  InputProps={{
                    className: classes.inputField
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.textFieldName,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  id="emailField"
                  name="Email id"
                  label="Email id"
                  variant="outlined"
                  type="email"
                  value={email}
                  helperText="Please make sure to enter the same emailID as previously provided "
                  required
                  square
                  onChange={(event) => {
                    setemail(event.target.value);
                  }}
                  InputProps={{
                    className: classes.inputField
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.textFieldName,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  id="addressField"
                  name="Address"
                  label="Address"
                  variant="outlined"
                  type="text"
                  value={address}
                  square
                  onChange={(event) => {
                    setaddress(event.target.value);
                  }}
                  InputProps={{
                    className: classes.inputField
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.textFieldName,
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Typography className={classes.heading1} >What's the reason for your visit?</Typography>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
            >
              <Select
                id="visitReasonSelect"
                value={selectedVisitReason}

                displayEmpty
                fullWidth
                onChange={(event, value) => {
                  if (value !== null) {
                    setSelectedVisitReason(value.props.value);
                    setSelecteVistReasonData(value.props.name);
                  }
                }}

              >
                {visitReasons.length == 0 && (
                  <MenuItem>None</MenuItem>
                )}
                {visitReasons.length > 0 && (
                  <MenuItem value="" disabled>
                    Please select your Reason *
                  </MenuItem>
                )}
                {visitReasons.length > 0 &&
                  Object.keys(visitReasons).map(
                    (key, index) => (
                      <MenuItem
                        value={
                          visitReasons[key]
                            .app_Reference_Values_statusId
                        }
                        name={
                          visitReasons[key]
                            .app_Reference_Values_statusName
                        }
                      >
                        {
                          visitReasons[key]
                            .app_Reference_Values_statusName
                        }

                      </MenuItem>
                    )
                  )}
              </Select>
            </FormControl>
            <Typography className={classes.heading1} >What's your insurance?</Typography>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth

            >
              <Select
                id="insNameSelect"
                value={selectedInsName}
                displayEmpty
                fullWidth
                onChange={(event, value) => {
                  if (value !== null) {
                    setSelectedInsName(value.props.value);
                    setselectedInsValue(value.props.name);
                    if (value.props.name === 'SELF PAY') {
                      document.getElementById("insuranceId").style.display = "none";
                      setinsMandatory(false);
                    }
                    else {
                      setIsPrimaryIns('yes');
                      setdisabled('yes');
                      document.getElementById("insuranceId").style.display = hideInsuranceIdConfig ? "none" : "block";
                      setinsMandatory(!hideInsuranceIdConfig);
                    }

                  }
                }}

              >
                {insNamesData.length == 0 && (
                  <MenuItem>None</MenuItem>
                )}
                {insNamesData.length > 0 && (
                  <MenuItem value="" disabled>
                    Please select your Insurance
                  </MenuItem>
                )}
                {insNamesData.length > 0 &&
                  Object.keys(insNamesData).filter((key) => insNamesData[key][0] !== "Self Pay" ? insNamesData[key][0] !== "UNREGSELF" ? insNamesData[key][0] : "" : "").map(
                    (key, index) => (

                      <MenuItem
                        value={insNamesData[key][1]}
                        name={insNamesData[key][0]}
                      >
                        {insNamesData[key][0]}
                      </MenuItem>

                    )
                  )}
              </Select>
            </FormControl>
            <div
              id="insuranceId"
              style={{ display: (hideInsuranceIdConfig) ? 'none' : 'block' }}
            >
              <Typography
                className={classes.heading1} style={{
                  padding: 0,

                }}>Insurance Id</Typography>
              <TextField
                fullWidth
                required
                id="insuranceNumber"
                name="insuranceNumber"
                variant="outlined"
                square
                value={insNum}
                onChange={checkTheInsNumberCount}
                InputProps={{
                  className: classes.inputField
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldName,
                  },
                }}
              />
            </div>
            <Typography className={classes.heading1} style={{
              padding: 0,

            }}>Are you a primary card holder</Typography>
            <RadioGroup

              aria-label="choice"
              name="primaryInsRadio"
              value={isPrimaryIns}
              onChange={handlePrimaryChange}
            >
              <Grid container md={6}>
                <Grid item md={3}>
                  <Paper square style={{ width: "100%", boxShadow: "none", marginLeft: 5 }}>
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                          size="small"
                        />
                      }
                      label={<span style={{ fontSize: 15 }}>No</span>}
                    />
                  </Paper>
                </Grid>
                <Grid item md={3}>
                  <Paper square style={{ width: "100%", boxShadow: "none", marginLeft: 5 }}>
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                          size="small"
                        />
                      }
                      label={<span style={{ fontSize: 15 }}>Yes</span>}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </RadioGroup>
            <div id="primaryCardInsuranceDetails" style={{ display: isPrimaryIns === 'yes' ? 'none' : 'block' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.heading1} style={{
                    padding: 0
                  }}>Primary card holder Last Name *</Typography>
                  <TextField
                    fullWidth
                    required
                    id="primaryHolderLname"
                    name="primaryHolderLname"
                    variant="outlined"
                    square
                    type="text"
                    value={primaryHolderLname}
                    onChange={(event) => setPrimaryHolderLname(event.target.value)}
                    InputProps={{
                      className: classes.inputField
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.textFieldName,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.heading1} style={{
                    padding: 0
                  }}>Primary card holder First Name *</Typography>
                  <TextField
                    fullWidth
                    required
                    id="primaryHolderFname"
                    name="primaryHolderFname"
                    variant="outlined"
                    square
                    type="text"
                    value={primaryHolderFname}
                    onChange={(event) => setPrimaryHolderFname(event.target.value)}
                    InputProps={{
                      className: classes.inputField
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.textFieldName,
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container md={12} spacing={2}>
                <Grid item md={6} >
                  <Typography className={classes.heading1} style={{
                    padding: 0
                  }}>Relationship to primary card holder</Typography>
                  <FormControl
                    variant="outlined"
                    size="small"
                    fullWidth
                  >
                    <Select
                      value={selectRelation}
                      displayEmpty
                      fullWidth
                      onChange={(event, value) => {
                        setSelectRelation(value.props.value);
                        setSelectRelationName(value.props.name);
                      }}
                    >
                      {referenceRelationData.length == 0 && (
                        <MenuItem>None</MenuItem>
                      )}
                      {referenceRelationData.length > 0 && (
                        <MenuItem value="" disabled>
                          Please select relationship
                        </MenuItem>
                      )}
                      {referenceRelationData.length > 0 &&
                        Object.keys(referenceRelationData).map(
                          (key, index) => (
                            <MenuItem
                              value={referenceRelationData[key].refid}
                              name={referenceRelationData[key].refno}
                            >
                              {referenceRelationData[key].refno}
                            </MenuItem>
                          )
                        )}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>

            {!isNewPatientHidden && (
              <div id="newPatientSection">
                <Typography className={classes.heading1} style={{
                  padding: 0
                }}>Are you a new patient?</Typography>
                <RadioGroup
                  aria-label="choice"
                  name="isNewPatientRadio"
                  value={isNewPatient}
                  onChange={handleChange}
                >
                  <Grid container md={6}>
                    <Grid item md={3} >
                      <Paper
                        square
                        className={classes.paper}
                        style={{ width: "100%", boxShadow: "none", }}>
                        <FormControlLabel
                          value="no"
                          style={{ width: "100%" }}
                          control={<Radio size="small" />}
                          label={
                            <span style={{ fontSize: 15 }}>No</span>
                          }
                        />
                      </Paper>
                    </Grid>
                    <Grid item md={3}>
                      <Paper

                        square
                        className={classes.paper}
                        style={{ width: "100%", boxShadow: "none", }}>
                        <FormControlLabel
                          value="yes"
                          style={{ width: "100%" }}
                          control={<Radio size="small" />}
                          label={
                            <span style={{ fontSize: 15 }}>Yes</span>
                          }
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </RadioGroup>
              </div>
            )}

            {/* Specialty Intake Questions — shown only when showSpecialtyQuestions=true and config exists */}
            {props.infoScreen.showSpecialtyQuestions && specialtyQuestionsConfig && specialtyQuestionsConfig.questions && specialtyQuestionsConfig.questions[props.infoScreen.specialtyType] && (
              <div>
                <Typography className={classes.heading1} style={{ padding: 0, fontWeight: 'bold' }}>
                  Additional Questions
                </Typography>
                {specialtyQuestionsConfig.questions[props.infoScreen.specialtyType].map((q, idx) => (
                  <React.Fragment key={q.id || idx}>
                    <Typography className={classes.heading1} style={{ padding: 0 }}>
                      {q.text} {q.mandatory && <span style={{ color: 'red' }}>*</span>}
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="Enter details"
                      value={specialtyAnswers[q.text] || ''}
                      onChange={(e) => setSpecialtyAnswers(prev => ({ ...prev, [q.text]: e.target.value }))}
                      InputProps={{ className: classes.inputField }}
                      InputLabelProps={{ classes: { root: classes.textFieldName } }}
                    />
                  </React.Fragment>
                ))}
              </div>
            )}

          </Grid>
          <Grid container
            className=
            {[
              classes.marginTop20,
              classes.centerContent
            ].join(" ")}>
            <Grid item md={12} direction="row">
              <Button
                variant="outlined"
                color="primary"
                size="large"
                style={{ textTransform: "none" }}
                onClick={confirmBooking}
              >
                Review booking
              </Button>
            </Grid>
          </Grid>
          <Button ref={ref} onClick={callExitVariable} style={{
            display: "none",
          }}>
            Exitpage
          </Button>
        </div>
      )}
      <Snackbar
        value="snackbar"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackBar}
        onClose={closeSnackBar}
        autoHideDuration={3000}
        message={snackBarMessage}
        key={[openSnackBar, snackBarMessage].join("_")}
      />
    </div>
  )
};
const PersonalInfo = React.forwardRef(PersonalInformation);
export default withStyles(styles)(PersonalInfo);
